export const URL_ENDPOINT_CAP_BAC_NHAN_VIEN = `${
  process.env.REACT_APP_ENDPOINT_URL
}/cap-bac`;

export const CAP_BAC_NHAN_VIEN_PREFIX_URL = "/cap-bac";
